import { useRef, useEffect } from "react";

import "./styles.css";

import { ReactComponent as DarkLogo } from "../../assets/logo/black-logo.svg";

import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";

import Button from "../Button";

export default function Header({
  links,
  collapsable = true,
  displayLogin = true,
}) {
  const REF_header = useRef(null);
  const lastScrollTop = useRef(0);
  const accumulatedScroll = useRef(0);
  const lastDirection = useRef(null);

  useEffect(() => {
    let timeoutId = null;

    const handleScroll = () => {
      if (!REF_header.current || !collapsable) return;

      const currentScroll = document.querySelector("main").scrollTop;
      const scrollDelta = currentScroll - lastScrollTop.current;
      const direction = scrollDelta > 0 ? "down" : "up";

      if (currentScroll < 30) {
        REF_header.current.classList.remove(
          "header-on-scroll",
          "header-collapsed"
        );
        accumulatedScroll.current = 0;
        return;
      } else {
        REF_header.current.classList.add("header-on-scroll");
      }

      if (direction !== lastDirection.current) {
        accumulatedScroll.current = 0;
        lastDirection.current = direction;
      }

      accumulatedScroll.current += Math.abs(scrollDelta);

      if (timeoutId) clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        if (accumulatedScroll.current > 30) {
          if (direction === "up") {
            REF_header.current.classList.remove("header-collapsed");
          } else {
            REF_header.current.classList.add("header-collapsed");
          }
          accumulatedScroll.current = 0;
          lastDirection.current = direction;
        }
      }, 30);

      lastScrollTop.current = currentScroll;
    };

    const screenElement = document.querySelector("main");

    if (screenElement) {
      screenElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (screenElement) {
        screenElement.removeEventListener("scroll", handleScroll);
      }
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  function handleRedirectToLogin() {
    if (window.top !== window.self) {
      window.open("https://app.ginastee.com/", "_blank"); // Abre a URL em uma nova aba
    } else {
      window.location.href = "https://app.ginastee.com/";
    }
  }

  const NavLink = ({ info }) => {
    function handleClick(event) {
      event.preventDefault(); // Evita o comportamento padrão do link

      document.querySelector(info.href)?.scrollIntoView({
        behavior: "smooth",
        block: "center", // Centraliza verticalmente
      });
    }
    return (
      <a onClick={handleClick} className="nav-link">
        <span>{info.text}</span>
        <ArrowDropDownRoundedIcon />
      </a>
    );
  };

  return (
    <nav ref={REF_header}>
      <DarkLogo className="nav-logo" />
      {links && (
        <div className="nav-links">
          {links.map((info, index) => (
            <NavLink info={info} key={index} />
          ))}
        </div>
      )}
      {displayLogin && (
        <div className="right-btns">
          <Button.PrimarySmall
            rightIcon={<LoginRoundedIcon />}
            onPress={handleRedirectToLogin}
            text="Fazer login"
          />
        </div>
      )}{" "}
    </nav>
  );
}
